
const Tabs = () => {
    return {
        MuiTabs: {
            styleOverrides : {
                vertical: {
                    overflow: 'visible'
                }
            }
        }
    };
}

export default Tabs;